import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";

export default function Footer({ content = {} }) {
  return (
    <footer className="border-t border-line bg-ink" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 lg:px-12 lg:py-24">
        <div>
          <p className="font-display text-2xl text-ivory">Martina Serra</p>
          <p className="label-caps mt-2 text-mist">Training &amp; Coaching</p>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-mute">
            Un allenamento costruito intorno a te, ai tuoi obiettivi e alla tua vita.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <p className="label-caps mb-2 text-ivory/50">Navigazione</p>
          {[
            ["Home", "/"],
            ["Chi sono", "/chi-sono"],
            ["Coaching", "/coaching"],
            ["Pacchetti", "/pacchetti"],
            ["Contatti", "/contatti"],
          ].map(([label, to]) => (
            <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(" ", "-")}`}
              className="text-sm text-mute transition-colors duration-300 hover:text-ivory">
              {label}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-3">
          <p className="label-caps mb-2 text-ivory/50">Legale &amp; Contatti</p>
          <Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-sm text-mute transition-colors duration-300 hover:text-ivory">Privacy Policy</Link>
          <Link to="/cookie-policy" data-testid="footer-link-cookie" className="text-sm text-mute transition-colors duration-300 hover:text-ivory">Cookie Policy</Link>
          <Link to="/termini-e-condizioni" data-testid="footer-link-termini" className="text-sm text-mute transition-colors duration-300 hover:text-ivory">Termini e condizioni</Link>
          <div className="mt-4 flex items-center gap-4">
            <a href={`mailto:${content.contact_email || "serramartinacoaching@gmail.com"}`} data-testid="footer-email"
              className="text-mute transition-colors duration-300 hover:text-mist" aria-label="Email">
              <Mail size={18} />
            </a>
            <a href={content.instagram_url || "https://www.instagram.com/serramartinaaa/"} target="_blank" rel="noopener noreferrer"
              data-testid="footer-instagram" className="text-mute transition-colors duration-300 hover:text-mist" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href={content.whatsapp_url || "https://wa.me/393248823603"} target="_blank" rel="noopener noreferrer"
              data-testid="footer-whatsapp" className="text-mute transition-colors duration-300 hover:text-mist" aria-label="WhatsApp">
              <MessageCircle size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-line py-6 text-center text-xs text-mute">
        © {new Date().getFullYear()} Martina Serra Training &amp; Coaching — Tutti i diritti riservati
        {content.legal_footer && (
          <span className="block mt-1" data-testid="footer-legal-info">{content.legal_footer}</span>
        )}
        <Link to="/admin" data-testid="footer-admin-link" className="ml-4 text-mute/50 transition-colors duration-300 hover:text-mute">Area riservata</Link>
      </div>
    </footer>
  );
}
